import React from "react"
import styled from "styled-components"

import { Img } from "wordsby-components"

export default function BackgroundImage(props) {
  return (
    <Container {...props}>
      <BackgroundImageStyles
        width={props.width}
        height={props.height}
        minHeight={props.minHeight}
        maxHeight={props.maxHeight}
        {...props}
      >
        {props.bg && (
          <Img
            field={props.bg}
            // fluid={props.bg.childImageSharp.fluid}
            // style={{
            //   objectFit: "cover",
            //   objectPosition: "50% 50%",
            //   fontFamily: "object-fit: cover; object-position: 50% 50%;"
            // }}
            // objectFit="cover"
            // objectPosition="50% 50%"
          />
        )}
        {props.children}
      </BackgroundImageStyles>
    </Container>
  )
}

const Container = styled.div`
  position: ${props => (props.position ? props.position : "relative")};
  top: 0;
  height: ${props => (props.height ? props.height : "100%")};
  min-height: ${props => (props.minHeight ? props.minHeight : "auto")};
  width: ${props => (props.width ? props.width : "100%")};
  overflow: hidden;
`

const BackgroundImageStyles = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 100%;

  .gatsby-image-wrapper {
    height: 100% !important;
    width: 100% !important;
  }
`
